import { alpha } from '@mui/material';

import { ITransparentItem } from './types';

export const transparentGenerator = (color: string): ITransparentItem => ({
  4: alpha(color, 0.04),
  8: alpha(color, 0.8),
  12: alpha(color, 0.12),
  16: alpha(color, 0.16),
  24: alpha(color, 0.24),
  32: alpha(color, 0.32),
  48: alpha(color, 0.48)
});
